
import React from 'react';

export const MapSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Find Us on Map
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Located conveniently in Vyttila Junction, Kochi. Easy access by public transport and ample parking available.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="aspect-w-16 aspect-h-9 h-96 md:h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.0234567890123!2d76.3186668593356!3d9.970602883213246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080d514abec6bf%3A0xbd582caa5844192!2sVyttila%2C%20Kochi%2C%20Kerala!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Device Doctor Location - Vyttila Junction, Kochi"
                className="w-full h-full"
              ></iframe>
            </div>
            
            <div className="p-8 bg-gradient-to-r from-red-600 to-red-700 text-white">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <h3 className="font-semibold mb-2">Address</h3>
                  <p className="text-red-100 text-sm">
                    Store no 1, Near Nakshatra Jewellery<br />
                    Vyttila Jn, Kochi 682019<br />
                    Kerala, India
                  </p>
                </div>
                
                <div className="text-center">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-car-line text-white text-xl"></i>
                  </div>
                  <h3 className="font-semibold mb-2">Parking</h3>
                  <p className="text-red-100 text-sm">
                    Free parking available<br />
                    Easy access from main road<br />
                    Public transport nearby
                  </p>
                </div>
                
                <div className="text-center">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-navigation-line text-white text-xl"></i>
                  </div>
                  <h3 className="font-semibold mb-2">Directions</h3>
                  <a 
                    href="https://maps.google.com/?q=9.970602883213246,76.3186668593356"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-white text-red-600 px-4 py-2 rounded-lg font-medium hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Get Directions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
